module.exports = __webpack_public_path__ + "img/报告厅暗.42683c84.png";